import useScreenSize from "../hooks/useScreenSize";

export default function OverallRating() {
  const { isMobile, isTablet } = useScreenSize();

  return (
    <section
      style={{
        background: "#F5F2EB",
        padding: isMobile ? "80px 20px" : "120px 32px",
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <p
          style={{
            color: "#C9A66B",
            letterSpacing: ".16em",
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: isMobile ? 12 : 14,
          }}
        >
          GUEST SATISFACTION
        </p>

        <h2
          style={{
            fontFamily: "'Fraunces', serif",
            fontSize: isMobile ? 36 : isTablet ? 44 : 52,
            color: "#222",
            margin: "18px 0 50px",
            lineHeight: 1.15,
          }}
        >
          Loved by guests,
          <br />
          trusted for every stay.
        </h2>

        <div
          style={{
            fontSize: isMobile ? 42 : 64,
            color: "#C9A66B",
            letterSpacing: 6,
            marginBottom: 16,
          }}
        >
          ★★★★★
        </div>

        <h1
          style={{
            fontFamily: "'Fraunces', serif",
            fontSize: isMobile ? 60 : isTablet ? 72 : 90,
            color: "#222",
            lineHeight: 1,
            margin: 0,
          }}
        >
          4.5
        </h1>

        <p
          style={{
            marginTop: 18,
            color: "#666",
            fontSize: isMobile ? 16 : 20,
          }}
        >
          Based on hundreds of verified guest reviews.
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile
              ? "1fr"
              : "repeat(auto-fit,minmax(220px,1fr))",
            gap: 24,
            marginTop: isMobile ? 50 : 70,
          }}
        >
          {[
            {
              name: "Google",
              rating: "4.5 / 5",
            },
            {
              name: "Goibibo",
              rating: "4.4 / 5",
            },
            {
              name: "Booking.com",
              rating: "8.9 / 10",
            },
          ].map((site) => (
            <div
              key={site.name}
              style={{
                background: "#FFF",
                border: "1px solid #DDD7CC",
                padding: isMobile ? "28px 20px" : "40px 24px",
              }}
            >
              <h3
                style={{
                  fontFamily: "'Fraunces', serif",
                  fontSize: isMobile ? 24 : 30,
                  color: "#222",
                  marginBottom: 16,
                }}
              >
                {site.name}
              </h3>

              <p
                style={{
                  fontSize: isMobile ? 28 : 34,
                  color: "#C9A66B",
                  margin: "0 0 12px",
                }}
              >
                ★★★★★
              </p>

              <p
                style={{
                  color: "#444",
                  fontSize: isMobile ? 16 : 18,
                  margin: 0,
                }}
              >
                {site.rating}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}